import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const HodynaZemliPage = () => {
  return (
    <Layout>
      <article>
        <h2>Година Землі</h2>

        <div className="grid top-spacing-big">
          <div className="grid__item">
            <StaticImage
              className="image"
              layout="constrained"
              width={640}
              height={360}
              formats={['auto', 'webp', 'avif']}
              src="../../images/news/hodyna-zemli/hodyna-zemli-1.jpeg"
              alt="Година Землі"
            />
          </div>
        </div>

        <p className="top-spacing-big">
          Можна багато розмірковувати про екологію та екологічні проблеми, шукати «винуватців» і дискутувати на тему, що
          стан навколишньої природи можливо був би зовсім іншим, якщо б...
        </p>

        <p>
          Все це можна робити і багато хто робить. У цьому немає нічого поганого, навіть навпаки: якщо ці міркування не
          будуть голослівними, то цілком природно, рано чи пізно це призведе безпосередньо до практичних кроків, адже
          ніхто не стане заперечувати, що діяльність людини на землі має ті чи інші наслідки.
        </p>

        <p>
          Людина - істота розумна. Звернувши увагу на актуальну проблему ми намагаємося її вирішити або принаймні
          згладити її наслідки. І це добре. У різних країнах на різних континентах стали організовуватися всілякі
          природоохоронні та екологічні товариства, організації і структури, проводитися ряд акцій та заходів по
          залученню уваги широкої громадськості до проблем природи та екології.
        </p>

        <p>
          <strong>
            Так виникла і організація WWF - Всесвітній фонд дикої природи, офіційна назва якої на даний момент World
            Wide Fund for Nature або «Всесвітній фонд природи»
          </strong>
          . Ця організація спільно з австралійським виданням <strong>«The Sydney Morning Herald»</strong> наприкінці
          березня <strong>2007</strong>-го року провела цікаву і показову екологічну акцію: близько{' '}
          <strong>2100</strong> фірм і компаній австралійського міста Сідней, а також понад <strong>2,2</strong> млн.
          його жителів вимкнули освітлення на одну годину . За цей час енергоспоживання міста було скорочено більше ніж
          на 10%, що в свою чергу сприяло і скороченню викидів вуглекислого газу в атмосферу.{' '}
          <strong>Цю акцію назвали «Година Землі»</strong>.
        </p>

        <h3 className="top-spacing-big">Чому Година Землі потрібна?</h3>

        <p>
          Вона не може зменшити споживання й виробництво електроенергії, бо великі підприємства не можуть вимикати своє
          обладнання на такий короткий час. Для декотрих, наприклад, лікарень, постійна електроенергія вкрай потрібна.
          Однак ця акція є способом привернути увагу до проблем планети, зокрема змін клімату, глобального потепління,
          забруднення довкілля, споживацтва, неправильного використання ресурсів.
        </p>

        <p>
          Завдяки Годині Землі чимало людей мають ще одну нагоду замислитися над своїм життям і почати зміни: розробляти
          нові ідеї й проєкти для покращення екологічної ситуації, чи принаймні навчитися правильно споживати воду
          вдома. І головне – БЕРЕГТИ І ЦІНУВАТИ МИР.
        </p>

        <h3 className="top-spacing-big">Як і коли проходить акція?</h3>

        <p>
          Акція проводиться <strong>25</strong> березня з <strong>20:30 до 21:30</strong> за місцевим часом. Взяти
          участь в ній може будь-хто. Для цього в будинку відключають світло і електроприлади. У події беруть участь
          також пам’ятки і міські будівлі, які на годину відключають підсвічування.
        </p>

        <p className="center-text bold-text italic-text">Доєднаємося до акції і ми!</p>
      </article>
    </Layout>
  );
};

export default HodynaZemliPage;

export const Head = () => <SEO title="Година Землі" />;
